// extracted by mini-css-extract-plugin
export default {"footer":"wHq9IeD0jFmwuZpa7va7"};